export default __webpack_public_path__ + "static/media/white_receipt.9a4c0aa0.svg";